import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { SharedService } from '../../../../../../../Services/shared.service';
import { CommonServices } from './../../../../../../../Services/common.service';
import { ApiService } from './../../../../../../../Services/api.service';
import { Subscription } from 'rxjs';
import { SweetAlert } from 'src/app/Services/sweetalet.service';

declare const Swal;

@Component({
  selector: 'g10-manage-group-verification',
  templateUrl: './manage-group-verification.component.html',
  styleUrls: ['./manage-group-verification.component.css']
})
export class ManageGroupVerificationComponent implements OnInit {

  @Input() popup = false;
  @Input() type;
  @Input() public set groupData(val){
    if (val!== undefined && Object.keys(val).length > 0){
    this.groupName = val.groupName;
    this.groupType = val.type;
    this.groupKey  = val.type == 'email' ? 'emailID' : 'mobileNo';
  }
}
  @Output() closeEvent: any = new EventEmitter();

  public groupName;
  public groupType;
  public groupKey;
  public manageGroupData = [];
  private searchEventSubscription: Subscription;
  public generateOTP: any = {};
  public subscribeTimer: any;

  public noDataEnable:boolean = false;

  constructor(
    private comservice: CommonServices,
    private share: SharedService,
    private api: ApiService,
    private swal:SweetAlert
  ) {

    

  }
  cancel() {

    this.closeEvent.emit(false)
  }
  // ngOnDestroy() {
  //   this.searchEventSubscription.unsubscribe();
  // }
  ngOnInit(): void {
    console.log(this.groupData,this.groupName);
    this.getManageGroupData();
  }

  getManageGroupData() {
    const obj = {
      groupName:this.groupName
    }; 
    this.api.transportManagerManageGroupList(obj).then((res: any) => {
      if (res.status == 'success') {
        this.manageGroupData = res.data;
        console.log(this.groupKey);
        console.log('Group Data',this.manageGroupData);
      }
      setTimeout(()=>{ this.noDataEnable = true; },300);
    }).catch((err) => {
      console.log(err);
    });
  }


  public timerOn: any = true;
  timer(remaining,id) {
    let m: any = Math.floor(remaining / 60);
    let s: any = remaining % 60;

    m = m < 10 ? '0' + m : m;
    s = s < 10 ? '0' + s : s;
    this.generateOTP[id]['timer']= m + ':' + s;
    // document.getElementById(id).innerHTML = m + ':' + s;
    // this.share._subject.next({type:'timer', data : m + ':' + s,id:id});
    remaining -= 1;
    let p= this;
    if (remaining >= 0 && this.timerOn) {
        setTimeout(function () {
           p.timer(remaining,id);
        }, 1000);
        return;
    }

    if (!this.timerOn) {
        // Do validate stuff here
        return;
    }

    this.generateOTP[id]['resend'] = true;
    // Do timeout stuff here
    // this.share._subject.next({type:'timer', data : false,id:id});
    // return false;
    // alert('Timeout for otp');
}

  verify(item) {
    let obj = {
      type: this.groupType
    }
    obj[this.groupKey] = item[this.groupKey];
    if (this.generateOTP[item[this.groupKey]] == undefined) this.generateOTP[item[this.groupKey]] = {};
    this.generateOTP[item[this.groupKey]]['verified'] = false;
    this.generateOTP[item[this.groupKey]]['resend'] = false;
    this.generateOTP[item[this.groupKey]]['inputValid']=true;    
    this.api.sendVerificationOTP(obj).then((data: any) => {
      if (data.status == 'success') {
        this.generateOTP[item[this.groupKey]]['enableOTP'] = true;
        this.generateOTP[item[this.groupKey]]['OTP']='';
       this.timer(60, item[this.groupKey]);

      }else delete this.generateOTP[item[this.groupKey]];

    })
  }

  cancelOTP(id){
    delete this.generateOTP[id];
  }

  verifyOTP(id){
    let otpValue:any = document.getElementById('otp_'+id);
    this.generateOTP[id]['OTP']=otpValue.value;
    if(this.generateOTP[id]['OTP']== undefined || this.generateOTP[id]['OTP']=='' ||this.generateOTP[id]['OTP']==null)
    {
      this.generateOTP[id]['inputValid']=false;
    }else{
      this.generateOTP[id]['inputValid']=true;
      let obj = {
        type: this.groupType,
        otp:Number(this.generateOTP[id]['OTP']),
      };
      obj[this.groupKey] = id;
      console.log(obj);
      this.api.VerifyOTP(obj).then((data: any) => {
        if (data.status == 'success') {
          this.generateOTP[id]['verified'] = true;
          this.generateOTP[id]['resend'] = false; 
          this.generateOTP[id]['enableOTP'] = false;
          this.getManageGroupData();
        }else{
          this.generateOTP[id]['verified'] = false;
          this.generateOTP[id]['resend'] = false; 
          this.generateOTP[id]['enableOTP'] = true;

          this.generateOTP[id]['inputValid']=true;
        }
      })
    } 
  }

  singleGrpDataDelete(id){
    Swal.fire({
      title: 'Are you sure?',
      text: 'You want to delete this!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor:  '#d33',//'#3085d6',
      //  cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!'
    }).then((result) => {
      if (result.isConfirmed) {
        console.log('delete click');
        this.deleteGroupData(id);
        /* Swal.fire(
          'Deleted!',
          'Your file has been deleted.',
          'success'
        ); */
      }
    });
  }
  deleteGroupData(id){
  let obj={
    groupName:this.groupName,
    groupID:id,
  }
  this.api.transportManagerManageGroupDelete(obj).then((res: any) => {
    if (res.status == 'success') {
      this.swal.swalFunction(res.status, res.status, res.message, 2000);
      this.getManageGroupData();
    }
    if (res.status == 'failure') {
      this.swal.swalFunction('error', res.status, res.message, 3000);
    }
  }).catch((err) => {
    console.log(err);
  });
}
}
